export default "/assets/images/mila-room-showcase-02.webp?06f8f844f3865268324ed66d05baf9cb";